module.exports = __webpack_public_path__ + "static/drive-5d2522971fc8f4c70dfe1a0916a2eda4.jpg";